<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Folder Tree" class="d-icon d-icon--folder-tree" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.793 1.293A1 1 0 0 1 6.5 1h1a1 1 0 0 1 .8.4l.45.6H10a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H6.5a1 1 0 0 1-1-1V2a1 1 0 0 1 .293-.707ZM7.5 2h-1v2.5H10V3H8.75a1 1 0 0 1-.8-.4L7.5 2Zm-.061 4.5a1 1 0 0 1 .898.55l.002.005.218.445H10a1 1 0 0 1 1 1V10a1 1 0 0 1-1 1H6.5a1 1 0 0 1-1-1V7.5a1 1 0 0 1 1-1h.939Zm.001 1H6.5V10H10V8.5H8.561m-1.118-1H7.44Z" fill="currentColor"/><path d="M2 1.5a.5.5 0 0 0-1 0V8c0 .826.674 1.5 1.5 1.5H4a.5.5 0 0 0 0-1H2.5A.503.503 0 0 1 2 8V3.914c.157.056.325.086.5.086H4a.5.5 0 0 0 0-1H2.5a.503.503 0 0 1-.5-.5v-1Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFolderTree',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
